import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { USERS_QUERY_KEY } from 'Data/keys/QueryKeys';
import { TenantApiV2 } from 'Data/Tenant.api.v2';

export const useQueryUsers = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [USERS_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await TenantApiV2.listUsers();
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
